import MilkPoolSummary from "./MilkPoolSummary";

export default function MilkPool({ aggregatedData }) {
    if (!aggregatedData?.milkPool?.totalMilkSolidsInTonnes) return null;

    return (
        <div className="HeroPanel u-mt-md u-page-break u-print-border">
            <div className="HeroPanel-title">Milk pool</div>
            <MilkPoolSummary aggregatedData={aggregatedData} />
        </div>
    );
}
